module.exports = "/_next/static/chromiums/og-1200x630-products-peach-blossom-lip-balm-4a194947ce1d6301417735041365d857.jpg";